import { Injectable, EventEmitter } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { Cookie } from '../cookies';
import { of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AuthService {
	private static readonly TOKEN_KEY = 'tkn';

	private static readonly API_PREFIX = AppSettings.API_ENDPOINT + 'auth/';
	private _token: string = null;
	private _userName: string = null;
	public onTokenChanged: EventEmitter<string>;
	public redirectUrl: string = null;

	constructor(private _http: Http, private _cookie: Cookie) {
		this.onTokenChanged = new EventEmitter();

		let cookieData = this._cookie.get(AuthService.TOKEN_KEY);
		if (cookieData) {
			let parts = cookieData.split('|');
			if (parts.length == 2) {
				this._token = parts[0];
				this._userName = parts[1];
			}
		}
	}

	getUserName(): string {
		return this._userName;
	}

	isLoggedIn(): boolean {
		return this._token && this._token.length > 0;
	}

	getToken(): string {
		return this._token;
	}

	login(userName: string, password: string): Observable<LoginResult> {
		return this._http
			.post(AuthService.API_PREFIX + 'login', {
				Username: userName,
				Password: password
			})
			.pipe(map(res => this.mapLoginResult(userName, res)))
			.pipe(catchError(this.catchError));
	}

	logout(): Observable<boolean> {
		this._token = null;
		this._cookie.remove(AuthService.TOKEN_KEY);
		this.onTokenChanged.emit(null);

		return of(true);
	}

	activate(userName: string, password: string): Observable<LoginResult> {
		return this._http
			.post(AuthService.API_PREFIX + 'activate', {
				Username: userName,
				Password: password
			})
			.pipe(map(res => this.mapLoginResult(userName, res)))
			.pipe(catchError(this.catchError));
	}

	private mapLoginResult(userName: string, res: Response) {
		let data = res.json() || {};

		this._userName = userName;

		if (this._token != data.token) {
			this._token = data.token;

			let cookieData = [data.token, userName].join('|');
			this._cookie.put(AuthService.TOKEN_KEY, cookieData);

			this.onTokenChanged.emit(data.token);
		}

		return data as LoginResult;
	}

	private catchError(error: Response | any) {
		let errMsg: string;
		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
			if (!error.ok && (error.status == 0 || error.status >= 500)) {
				errMsg = 'Internal server error';
			}

		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return throwError(errMsg);
	}
}

export interface LoginResult {
	success: boolean;
	token: string;
	error: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/auth.service.ts